import { BUSINESS } from "@/constants/business";
import { useLang } from "@/context/LangContext";
import { STRINGS } from "@/i18n";

export default function Nav() {
  const { lang, toggle } = useLang();
  const t = STRINGS[lang];
  return (
    <nav className="sticky top-0 z-50 border-b border-white/10 bg-[#0d0906]/90 backdrop-blur-md px-6 py-4 flex items-center justify-between max-w-7xl mx-auto">
      <div className="flex items-center gap-3">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className="text-[#a4133c]" aria-hidden="true">
          <path d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2Z" stroke="currentColor" strokeWidth="1.5" strokeDasharray="2 2" />
          <path d="M12 6C9 9 7 12 7 15C7 17.8 9.2 20 12 20C14.8 20 17 17.8 17 15C17 12 15 9 12 6Z" fill="#a4133c" fillOpacity="0.3" stroke="currentColor" strokeWidth="1.5" />
        </svg>
        <span data-testid="brand-name" className="serif-disp text-lg sm:text-xl tracking-wider text-white uppercase font-light whitespace-nowrap">
          {BUSINESS.brand}
        </span>
        <span className="script-accent text-xl text-[#c9933b] hidden sm:inline -ml-1">by Mocha</span>
        <span className="mono-lbl text-[10px] tracking-widest text-[#a4133c] uppercase border border-[#a4133c]/40 px-2 py-0.5 rounded-full hidden md:inline whitespace-nowrap">
          Licensed LMT
        </span>
      </div>
      <div className="hidden md:flex items-center gap-8 text-xs uppercase tracking-widest text-neutral-400">
        <a href="#services" className="hover:text-white transition-colors">{t.nav.treatments}</a>
        <a href="#about" className="hover:text-white transition-colors">{t.nav.therapist}</a>
        <a href="#credentials" className="hover:text-white transition-colors">{t.nav.credentials}</a>
        <a href="#booking" className="hover:text-white transition-colors">{t.nav.booking}</a>
      </div>
      <div className="flex items-center gap-3">
        <button
          data-testid="lang-toggle-btn"
          onClick={toggle}
          aria-label="Switch language / Cambiar idioma"
          className="mono-lbl text-[10px] tracking-widest uppercase border border-[#c9933b]/50 text-[#c9933b] hover:bg-[#c9933b]/15 px-3 py-1.5 rounded-full transition-all"
        >
          {lang === "en" ? "ES" : "EN"}
        </button>
        <a
          data-testid="nav-request-slot-btn"
          href="#booking"
          className="px-3 sm:px-4 py-2 bg-[#800f2f] hover:bg-[#a4133c] text-white text-xs uppercase tracking-wider rounded transition-all whitespace-nowrap"
        >
          {t.nav.requestSlot}
        </a>
      </div>
    </nav>
  );
}
